import React from "react";
import CreateStudentForm from "../../components/Forms/CreateStudentForm";

const CreateStudent = ({
  updateStudents,
  dismissModal,
  classes,
  studentClassId,
}) => {
  return (
    <div className="animated fadeIn">
      <CreateStudentForm
        updateStudents={updateStudents}
        dismissModal={dismissModal}
        studentClasses={classes}
        studentClassId={studentClassId}
      />
    </div>
  );
};

export default CreateStudent;
